import '../styles/Home.css';
import { Link } from 'react-router-dom';
import { useState } from 'react';

function Home() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  const blogPosts = [
    {
      date: 'June 5, 2024',
      title: 'How Lean Reduces Operational Costs Without Compromising Quality',
      bullets: [
        'Remove activities that don\'t add value',
        'Improve process flow for faster operations',
        'Less rework, fewer delays, reduced defects',
        'Better capacity utilization'
      ],
      category: 'Lean Consulting',
      image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=350&fit=crop'
    },
    {
      date: 'May 28, 2024',
      title: 'Lean vs Six Sigma: Understanding the Difference',
      bullets: [
        'Lean improves speed and flow',
        'Six Sigma reduces variation and defects',
        'Lean Six Sigma combines both approaches',
        'Comprehensive operational improvement'
      ],
      category: 'Six Sigma',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=350&fit=crop'
    },
    {
      date: 'May 15, 2024',
      title: 'Building Sustainable Operational Improvements That Stick',
      bullets: [
        'Why improvement initiatives lose momentum',
        'Best practices for embedding change',
        'Building team capability',
        'Sustaining improvements long-term'
      ],
      category: 'Organizational Excellence',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=350&fit=crop'
    },
    {
      date: 'April 30, 2024',
      title: 'Why SMEs Benefit Most From Lean Consulting',
      bullets: [
        'Improve productivity and reduce bottlenecks',
        'Create clearer processes',
        'Enable growth without unnecessary complexity',
        'Tailored for smaller organisations'
      ],
      category: 'Lean Consulting',
      image: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=600&h=350&fit=crop'
    },
    {
      date: 'April 10, 2024',
      title: 'Lean Six Sigma Across Industries: Beyond Manufacturing',
      bullets: [
        'Applies to service, healthcare, finance, construction',
        'Technology and professional services',
        'Any process can be improved',
        'Principles are universal'
      ],
      category: 'Business Transformation',
      image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&h=350&fit=crop'
    },
    {
      date: 'March 25, 2024',
      title: 'Common Sources of Process Waste: A Practical Guide',
      bullets: [
        'Rework and delays',
        'Excess inventory',
        'Underutilised capacity',
        'Learn to spot and eliminate waste'
      ],
      category: 'Process Improvement',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=350&fit=crop'
    }
  ];

  const stats = [
    { number: '10+', label: 'Years of experience' },
    { number: '6', label: 'Core Service Area' },
    { number: 'UK . EU', label: '& International reach' },
    { number: 'CMC', label: 'Chartered Standard' }
  ];

  const challenges = [
    {
      title: 'Processes that have grown without design',
      description: 'Over time, processes accumulate steps, workarounds and duplication that were never intended. The result is unnecessary complexity, avoidable delays and waste that becomes the norm rather than the exception.'
    },
    {
      title: 'Limited performance visibility for leaders',
      description: 'Without clear metrics and visibility into operational performance, leadership teams struggle to identify root causes and make informed decisions about where to invest improvement effort.'
    },
    {
      title: 'Variation across teams, sites and functions',
      description: 'Different teams work in different ways, creating inconsistent results, customer experience, and quality. This variation amplifies complexity and makes scaling improvements difficult.'
    },
    {
      title: 'Improvement initiatives that lose momentum',
      description: 'Many improvement projects fail to stick. Without proper change management, capability building, and embedded new ways of working, teams drift back to old patterns.'
    }
  ];

  const carouselItems = [
    'Chartered Management Consultancy',
    'Lean Six Sigma Green Belt expertise',
    'Process Improvement',
    'Operational Excellence',
    'Consultancy, training & coaching',
    'Business Transformation'
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <div className="ellipse ellipse-2"></div>
          <div className="ellipse ellipse-3"></div>
          <div className="ellipse ellipse-4"></div>
          <div className="ellipse ellipse-5"></div>
        </div>

        <div className="hero-container">
          {/* Main Heading */}
          <h1 className="hero-heading">
            Chartered Management Consultancy.
          </h1>
          <p className="hero-subheading">
            Lean consulting built for real operational change.
          </p>

          {/* CTA Buttons */}
          <div className="hero-ctas">
            <Link to="/contact" className="cta-primary">Book a Consultation</Link>
            <Link to="/services" className="cta-secondary">
              Explore Our Services
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M5 12H19M12 5L19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          </div>

          {/* Right Image */}
          <div className="hero-image">
            <img
              src="/Ellipse.jpg"
              alt="Business consultation handshake"
              className="hero-image-circle"
            />
            <div className="floating-images">
              <img src="/Ellipse4.png" alt="" className="float-item float-1" />
              <img src="/Ellipse3.jpg" alt="" className="float-item float-2" />
              <img src="/Ellipse1.jpg" alt="" className="float-item float-3" />
              <img src="/Ellipse2.jpg" alt="" className="float-item float-4" />
            </div>
          </div>
        </div>
      </section>

      {/* Carousel Section */}
      <section className="carousel">
        <div className="carousel-content">
          {[...carouselItems, ...carouselItems].map((item, index) => (
            <div
              key={`${item}-${index}`}
              className="carousel-item"
              aria-hidden={index >= carouselItems.length}
            >
              <span className="carousel-dot"></span>
              <span className="carousel-text">{item}</span>
            </div>
          ))}
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="stats-container">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
              {index < stats.length - 1 && <div className="stat-divider"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Challenge Section */}
      <section className="challenge">
        <div className="challenge-container">
          <div className="challenge-left">
            <h3 className="challenge-label">THE CHALLENGE</h3>
            <h2 className="challenge-heading">Operational problems compound when left unresolved.</h2>
            <ul className="challenge-description bullet-list">
              <li>Inefficiency spreads beyond one process or team over time</li>
              <li>Waste, delays, rework and inconsistent performance affect cost, quality and delivery</li>
              <li>The ability to grow becomes constrained</li>
              <li>CKS Innovation identifies root causes and improves how work flows across the organisation</li>
              <li>Practical improvements are embedded to hold over time</li>
            </ul>
          </div>

          <div className="challenge-right">
            {challenges.map((challenge, index) => (
              <div key={index} className="challenge-card">
                <div className="challenge-item">
                  <h4 className="challenge-item-title">{challenge.title}</h4>
                  <div className="challenge-item-icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                      <circle cx="16" cy="16" r="14" fill="#EF593B"/>
                      <path d="M16 11V21M11 16H21" stroke="white" strokeWidth="2.2" strokeLinecap="round"/>
                    </svg>
                  </div>
                </div>
                {challenge.description && (
                  <p className="challenge-item-description">{challenge.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>

        <div className="challenge-quote">
          "The goal is not to run improvement projects in isolation — it is to build organisations that improve continuously."
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="why-choose-container">
          <div className="why-choose-header">
            <h3 className="section-label">WHY CHOOSE US</h3>
            <h2 className="section-heading">A consultancy built on real-world operational expertise</h2>
          </div>

          <div className="why-choose-grid">
            <div className="why-choose-card">
              <div className="why-choose-image-wrapper">
                <img
                  src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop"
                  alt="Team collaboration in meeting room"
                  className="why-choose-image"
                />
              </div>
              <h4 className="why-choose-title">Hands-on Collaboration</h4>
              <ul className="why-choose-desc bullet-list">
                <li>Work alongside your teams, not from a distance</li>
                <li>Consultants embed within your operations</li>
                <li>Drive change from the inside</li>
              </ul>
            </div>

            <div className="why-choose-card">
              <div className="why-choose-image-wrapper">
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop"
                  alt="Data analytics dashboard on screen"
                  className="why-choose-image"
                />
              </div>
              <h4 className="why-choose-title">Data-Driven Decisions</h4>
              <ul className="why-choose-desc bullet-list">
                <li>Every recommendation backed by rigorous analysis</li>
                <li>Lean Six Sigma methodology to identify root causes</li>
                <li>Measurable improvement at every stage</li>
              </ul>
            </div>

            <div className="why-choose-card">
              <div className="why-choose-image-wrapper">
                <img
                  src="https://images.unsplash.com/photo-1521737711867-e3b97375f902?w=600&h=400&fit=crop"
                  alt="Professional training workshop"
                  className="why-choose-image"
                />
              </div>
              <h4 className="why-choose-title">Capability Building</h4>
              <ul className="why-choose-desc bullet-list">
                <li>Build your team's ability to solve problems independently</li>
                <li>Training, coaching, and mentoring included</li>
                <li>Not just fixing problems — building lasting skills</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Our Approach Section */}
      <section className="our-approach">
        <div className="approach-container">
          <div className="approach-content" style={{ display: 'block', textAlign: 'left', width: '100%' }}>
            <h3 className="section-label">OUR APPROACH</h3>
            <h2 className="approach-heading">Structured improvement that delivers lasting results</h2>
            <ul className="approach-text bullet-list">
              <li>Combine Lean thinking, Six Sigma rigour, and practical change management</li>
              <li>Transform how organisations operate</li>
              <li>Create sustainable improvement — not short-term fixes</li>
            </ul>
          </div>
          <div className="approach-steps">
            <div className="approach-step">
              <span className="step-number">01</span>
              <span className="step-text">Diagnose & Understand</span>
            </div>
            <div className="approach-step">
              <span className="step-number">02</span>
              <span className="step-text">Design & Improve</span>
            </div>
            <div className="approach-step">
              <span className="step-number">03</span>
              <span className="step-text">Implement & Embed</span>
            </div>
            <div className="approach-step">
              <span className="step-number">04</span>
              <span className="step-text">Sustain & Scale</span>
            </div>
          </div>
          <div className="approach-images">
            <img
              src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=600&h=700&fit=crop"
              alt="Business strategy planning session"
              className="approach-img-main"
            />
            <img
              src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=300&h=300&fit=crop"
              alt="Team working on process improvement"
              className="approach-img-secondary"
            />
          </div>
        </div>
      </section>

      {/* Blog & Insights Section */}
      <section className="home-blog">
        <div className="home-blog-container">
          <div className="home-blog-header">
            <h3 className="section-label">BLOG &amp; INSIGHTS</h3>
            <h2 className="section-heading">Thoughts, strategies &amp; best practices</h2>
            <p className="home-blog-sub">Practical insights on operational excellence, Lean Six Sigma, and business transformation.</p>
          </div>
          <div className="home-posts-grid">
            {blogPosts.map((post, index) => (
              <article key={index} className="home-blog-card">
                <div className="home-blog-image-wrapper">
                  <img src={post.image} alt={post.title} className="home-blog-image" />
                  <span className="home-blog-category">{post.category}</span>
                </div>
                <div className="home-blog-body">
                  <span className="home-blog-date">{post.date}</span>
                  <h3 className="home-blog-title">{post.title}</h3>
                  <ul className="home-blog-bullets">
                    {post.bullets.map((bullet, i) => (
                      <li key={i}>{bullet}</li>
                    ))}
                  </ul>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="home-newsletter">
        <div className="home-newsletter-container">
          <div className="home-newsletter-icon">
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none">
              <path d="M4 8H32V28H4V8Z" stroke="white" strokeWidth="2" strokeLinejoin="round"/>
              <path d="M4 8L18 20L32 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2 className="home-newsletter-heading">Subscribe to Our Newsletter</h2>
          <p className="home-newsletter-sub">Get the latest insights on operational excellence delivered to your inbox</p>
          {subscribed ? (
            <div className="home-newsletter-success">
              ✓ Thank you for subscribing! We'll be in touch.
            </div>
          ) : (
            <form className="home-newsletter-form" onSubmit={handleNewsletter}>
              <input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="home-newsletter-input"
              />
              <button type="submit" className="home-newsletter-btn">Subscribe</button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
}

export default Home;
